requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    const TAG = '[list-info]';

    const sectionURL = (id) => {
      const u = new URL(window.location.pathname, window.location.origin);
      u.searchParams.set('section_id', id);
      u.searchParams.set('_cb', String(Date.now()));
      return u.toString();
    };

    async function fetchBody(sectionId, kind) {
      const url = sectionURL(sectionId);
      try {
        const res = await fetch(url, {
          credentials: 'same-origin'
        });
        if (!res.ok) {
          console.warn(TAG, 'fetch non-200', {
            status: res.status,
            kind,
            sectionId
          });
          return '';
        }
        const html = await res.text();

        const wrap = document.createElement('div');
        wrap.innerHTML = html;

        let sec = wrap.querySelector('section');
        let body = sec && sec.querySelector('.product-lists-info__body');
        if (body) return body.outerHTML;

        body = wrap.querySelector('.product-lists-info__body');
        if (body) return body.outerHTML;

        console.warn(TAG, 'body not found in section html', {
          kind,
          sectionId
        });
        return '';
      } catch (err) {
        console.error(TAG, 'fetch error', {
          kind,
          sectionId,
          err
        });
        return '';
      }
    }

    class ProductListsInfoBase extends HTMLElement {
      constructor(kind) {
        super();
        this.kind = kind;
        this.sectionId = null;
        this.loading = false;
        this.raf = null;

        this.onCoreChange = this.onCoreChange.bind(this);
        this.onGenericSignal = this.onGenericSignal.bind(this);
      }

      connectedCallback() {
        this.sectionId = this.getAttribute('data-section-id') || '';
        if (!this.sectionId) {
          console.warn(TAG, 'no data-section-id attribute — skip init', {
            kind: this.kind,
            el: this
          });
          return;
        }

        this.refresh();

        document.addEventListener('product-lists:change', this.onCoreChange);

        const evts = [
          `${this.kind}:changed`,
          `${this.kind}:pairs-changed`,
          `${this.kind}:ui-updated`,
          `${this.kind}-section:updated`,
          'compare-section:updated',
          'cart:attributes:updated',
        ];
        this._events = evts;
        evts.forEach((e) => document.addEventListener(e, this.onGenericSignal));

      }

      disconnectedCallback() {
        document.removeEventListener('product-lists:change', this.onCoreChange);
        (this._events || []).forEach((e) => document.removeEventListener(e, this.onGenericSignal));
        this._events = [];
        if (this.raf) cancelAnimationFrame(this.raf);
      }

      onCoreChange(ev) {
        const d = (ev && ev.detail) || {};
        if (d.list !== this.kind) return;
        this.scheduleRefresh();
      }

      onGenericSignal(ev) {
        this.scheduleRefresh();
      }

      scheduleRefresh() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          this.refresh();
        });
      }

      async refresh() {
        if (this.loading || !this.sectionId) return;
        this.loading = true;
        try {
          const inner = await fetchBody(this.sectionId, this.kind);
          if (inner) {
            this.innerHTML = inner;
          } else {}
        } catch (err) {} finally {
          this.loading = false;
        }
      }
    }

    class CompareInfo extends ProductListsInfoBase {
      constructor() {
        super('compare');
      }
    }
    if (!customElements.get('compare-info')) customElements.define('compare-info', CompareInfo);

  });
});